<template>
  <div class="device-modify common-page">
    <!-- 面包屑 -->
    <a-breadcrumb>
      <a-breadcrumb-item>设备管理</a-breadcrumb-item>
      <a-breadcrumb-item>修改</a-breadcrumb-item>
    </a-breadcrumb>

    <!-- 设备信息 -->
    <section class="common-box">
      <div class="common-box-title">设备信息</div>
      <div class="common-box-body">
        <a-form :form="form">
          <a-row>
            <a-col :span="8">
              <a-form-item label="生产者姓名" v-bind="formItemLayout">
                <a-input
                  placeholder="请输入生产者姓名"
                  maxlength="64"
                  v-decorator="[ 
                    'producerName',
                    {
                      rules: [
                        { required: true, message: '请输入生产者姓名', whitespace: true }
                      ],
                    }
                  ]"
                />
              </a-form-item>
            </a-col>

            <a-col :span="8">
              <a-form-item label="剩余激活次数" v-bind="formItemLayout">
                <a-input-number
                  placeholder="请输入剩余激活次数"
                  style="width: 100%;"
                  :min="0"
                  v-decorator="[ 
                    'activationNumber',
                    {
                      rules: [
                        { required: true, message: '请输入剩余激活次数' }
                      ],
                    }
                  ]"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </section>

    <!-- 功能 -->
    <section class="common-box">
      <div class="common-box-title">功能授权</div>
      <div class="common-box-body">
        <a-table :columns="columns_func" :rowKey="(record, index) => index" :dataSource="data_func" :pagination="false">
          <!-- 功能名称 -->
          <template slot="functionId" slot-scope="text">
            <span>{{getFuncNameByID(text)}}</span>
          </template>

          <!-- 授权开始时间 -->
          <template slot="startTime" slot-scope="text, record">
            <a-date-picker
              :allowClear="false"
              :value="text?moment(text):moment('1970-01-01','YYYY-MM-DD')"
              v-if="record.editable"
              @change="e => handleChange(e.valueOf(), record.index, 'startTime')"
              style="margin: -6px 0"
            />
            <span v-else>{{text?moment(text).format('YYYY-MM-DD'):'1970-01-01'}}</span>
          </template>

          <!-- 授权结束时间 -->
          <template slot="endTime" slot-scope="text, record">
            <a-date-picker
              :allowClear="false"
              :value="text?moment(text):undefined"
              v-if="record.editable"
              @change="e => handleChange(e.valueOf(), record.index, 'endTime')"
              style="margin: -6px 0"
            />
            <span v-else>{{text?moment(text).format('YYYY-MM-DD'):'永久'}}</span>
          </template>

          <!-- 功能授权操作 -->
          <template slot="action" slot-scope="text, record">
            <template v-if="record.editable">
              <span class="cant-select">
                <a @click="saveRow(record)">保存</a>
                <a-divider type="vertical" />
                <a @click="cancel(record.index)">取消</a>
              </span>
            </template>
            <span v-else class="cant-select">
              <a @click="toggle(record.index)">编辑</a>
            </span>
          </template>

          <!-- 授权状态 -->
          <template slot="enabled" slot-scope="text, record">
            <a-switch :checked="text" @change="e => handleChange(e, record.index, 'enabled')" />
          </template>
        </a-table>
      </div>
    </section>

    <!-- 扩展属性 -->
    <section class="common-box">
      <div class="common-box-title">扩展属性</div>
      <div class="common-box-body">
        <a-table :columns="columns_attr" :rowKey="(record, index) => index" :dataSource="data_attr" :pagination="false">
          <!-- 值 -->
          <template slot="value" slot-scope="text, record">
            <a-input
              :allowClear="false"
              :value="text"
              v-if="record.editable"
              style="margin: -6px 0"
              maxlength="64"
              @change="e => handleChangeAttr(e.target.value, record.index, 'value')"
            />
            <span v-else>{{text}}</span>
          </template>

          <!-- 扩展属性操作 -->
          <template slot="action" slot-scope="text, record">
            <template v-if="record.editable">
              <span class="cant-select">
                <a @click="saveRowAttr(record)">保存</a>
                <a-divider type="vertical" />
                <a @click="cancelAttr(record.index)">取消</a>
              </span>
            </template>
            <span v-else class="cant-select">
              <a @click="toggleAttr(record.index)">编辑</a>
            </span>
          </template>
        </a-table>
      </div>
    </section>

    <section class="submit-box">
      <a-button type="primary" @click="submit" :loading="loading">提交</a-button>
    </section>
  </div>
</template>

<script>
import moment from 'moment'
import { queryDevicesAllInfo, queryFunctions, editDevice } from '../api/api'

const columns_func = [
  {
    title: '功能名称',
    dataIndex: 'functionId',
    width: '20%',
    scopedSlots: { customRender: 'functionId' }
  },
  {
    title: '授权开始时间',
    dataIndex: 'startTime',
    scopedSlots: { customRender: 'startTime' },
    width: '20%'
  },
  {
    title: '授权结束时间',
    dataIndex: 'endTime',
    scopedSlots: { customRender: 'endTime' },
    width: '20%'
  },
  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
    width: '20%'
  },
  {
    title: '授权状态',
    dataIndex: 'enabled',
    scopedSlots: { customRender: 'enabled' },
    width: '20%'
  }
]

const columns_attr = [
  {
    title: '属性名',
    dataIndex: 'key',
    width: '25%'
  },
  {
    title: '属性英文名',
    dataIndex: 'keyEn',
    width: '25%'
  },
  {
    title: '属性值',
    dataIndex: 'value',
    width: '25%',
    scopedSlots: { customRender: 'value' }
  },
  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
    width: '25%'
  }
]

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 }
  }
}

export default {
  name: 'device-modify',

  data() {
    return {
      form: this.$form.createForm(this),
      formItemLayout,
      columns_func,
      columns_attr,
      data_func: [],
      data_attr: [],
      devices: [],
      device: {},
      loading: false,
      functions: []
    }
  },

  computed: {
    deviceID() {
      return parseInt(this.$route.query.deviceID)
    },

    productID() {
      return parseInt(this.$route.query.productID)
    },

    serialNumber() {
        return this.$route.query.serialNumber
    }
  },

  created() {
    this.fetchData()
    this.queryFunctions()
  },

  methods: {
    moment,

    fetchData() {
        const para = {
            keys: {
                serialNumber: this.serialNumber,
                stime: -28800000,
                etime: 11587891746587
            }
        }
      queryDevicesAllInfo(para).then(res => {
        if (res.error.code === 0) {
          this.devices = res.response ? res.response.records : []
          this.device = this.devices.find(device => device.id === this.deviceID)
          if (this.device && this.device.extendedAttributes) {
            this.data_attr = [...this.device.extendedAttributes]
            if (this.data_attr.length > 0) {
              this.data_attr.forEach((item, index) => {
                this.$set(item, 'editable', false)
                this.$set(item, 'index', index + 1)
              })
            }
          }

          if (this.device && this.device.functions) {
            this.data_func = [...this.device.functions]
            this.data_func.forEach((item, index) => {
              this.$set(item, 'editable', false)
              this.$set(item, 'index', index + 1)
            })
          }

          this.initFormValue()
        }
      })
    },

    queryFunctions() {
      queryFunctions().then(res => {
        if (res.error.code === 0) {
          this.functions = res.response ? res.response.functions : []
        }
      })
    },

    getFuncNameByID(id) {
      return this.functions.find(item => item.id == id).name
    },

    initFormValue() {
      this.form.setFieldsValue({
        producerName: this.device.producerName,
        activationNumber: this.device.activableNumber
      })
    },

    submit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true

          let device = {
            deviceID: this.deviceID,
            producerName: values.producerName,
            activationNumber: values.activationNumber,
            functions: this.data_func.map(item => {
              return {
                id: item.functionId,
                enabled: item.enabled,
                startTime: item.startTime,
                endTime: item.endTime
              }
            }),
            extendedAttributes: this.data_attr.map(item => {
              return {
                key: item.key,
                keyEn: item.keyEn,
                value: item.value
              }
            })
          }

          if (this.data_func.some(item => item.editable === true)) {
            this.$message.error('请点击【保存】功能授权')
            this.loading = false
            return
          }

          if (this.data_attr.some(item => item.editable === true)) {
            this.$message.error('请点击【保存】扩展属性')
            this.loading = false
            return
          }

          editDevice(device).then(res => {
            if (res.error.code === 0) {
              this.$message.success('修改成功')
            }
            this.loading = false
          })
        }
      })
    },

    //编辑
    toggle(index) {
      const target = this.data_func.find(item => item.index === index)
      target._originalData = { ...target }
      target.editable = !target.editable
    },

    //取消
    cancel(index) {
      const target = this.data_func.find(item => item.index === index)
      Object.keys(target).forEach(key => {
        target[key] = target._originalData[key]
      })
      target._originalData = undefined
    },

    //保存
    saveRow(record) {
      const { index } = record
      const target = this.data_func.find(item => item.index === index)
      target.editable = false
    },

    handleChange(value, index, column) {
      const newData = [...this.data_func]
      const target = newData.find(item => index === item.index)
      if (target) {
        target[column] = value
        this.data_func = newData
      }
    },

    toggleAttr(index) {
      const target = this.data_attr.find(item => item.index === index)
      target._originalData = { ...target }
      target.editable = !target.editable
    },

    cancelAttr(index) {
      const target = this.data_attr.find(item => item.index === index)
      Object.keys(target).forEach(key => {
        target[key] = target._originalData[key]
      })
      target._originalData = undefined
    },

    saveRowAttr(record) {
      const { index } = record
      const target = this.data_attr.find(item => item.index === index)
      target.editable = false
    },

    handleChangeAttr(value, index, column) {
      const newData = [...this.data_attr]
      const target = newData.find(item => index === item.index)
      if (target) {
        target[column] = value
        this.data_attr = newData
      }
    }
  }
}
</script>

<style lang="less" scoped>
.device-modify {
  margin-bottom: 56px;
}
</style>